<template>
	<section class="question">
		<div class="question-flash-header-wrapper page__title page__title--with-buttons">
			<h1>Questions Flash</h1>
			<div class="button__container">
				<router-link class="button button--secondary" :to="{name:'MyResourcesAddQuestion'}">✏️ Créer une question</router-link>
				<button class="button button--primary" @click="openModal">✨ Générer une question</button>
			</div>
		</div>
		<p class="page__description">Créez des diaporamas de questions Flash à vidéoprojeter en classe. Il suffit de séléctionner vos questions dans la base de données. Cela se fait en quelques clics !</p>
		<a class="page__open-info" @click="isPopUpFlashVisible = !isPopUpFlashVisible">Comment ça marche ?</a>
		<filterWrapper
			@updateFilter="updateFilter"
		/>
		<router-view v-slot="{ Component }">
			<transition name="route">
				<component
					class="main-component"
					:is="Component"
					:filter="filter"
					v-if="Component"
					@refresh-questions="handleRefreshQuestions"
					@openGenerateModal="openModalWithFilters"
				/>
			</transition>
		</router-view>
		<pop-up-flash
			v-if="isPopUpFlashVisible"
			@close="isPopUpFlashVisible = false"
		/>
		<GenerateFlashQuestionModal
			v-if="isModalVisible"
			@close="closeModal"
			@questionAdded="closeModal"
			:prefilledSubject="modalFilters.subject"
			:prefilledLevel="modalFilters.level"
			:prefilledChapter="modalFilters.chapter"
		/>
	</section>
</template>

<script>

import PopUpFlash from '../../../PopUp/PopUpFlash.vue'
import FilterWrapper from '../FilterWrapper.vue';
import GenerateFlashQuestionModal from '@/components/Admin/modals/GenerateFlashQuestionModal.vue';

export default {
	components: {
		PopUpFlash,
		FilterWrapper,
		GenerateFlashQuestionModal
	},
	data() {
		return {
			isPopUpFlashVisible: false,
			// spanWidth: 0,
			// spanPosition: 0,
			isModalVisible: false,
			modalFilters: {
				subject: null,
				level: null,
				chapter: null
			},
			filter: {
				chapter: null,
				subject: null,
				level: null,
				type: [],
				theme: [],
				difficulty: [],
				offset: 0,
				search: '',
			},
		}
	},

	methods: {
		updateFilter(data) {
			this.filter.level = data.level
			this.filter.subject = data.subject
			this.filter.chapter = data.chapter
			this.filter.search = data.search
			this.filter.teacher = data.teacher
		},
		handleRefreshQuestions() {
			// Méthode vide pour éviter le warning Vue
		},
		openModal() {
			// Ouverture normale (depuis le bouton principal) - pas de pré-remplissage
			this.modalFilters = {
				subject: null,
				level: null,
				chapter: null
			}
			this.isModalVisible = true
		},
		openModalWithFilters(filterData) {
			// Ouverture avec filtres pré-remplis (depuis NoContent)
			if (filterData) {
				this.modalFilters = {
					subject: filterData.subject,
					level: filterData.level,
					chapter: filterData.chapter
				}
			} else {
				this.modalFilters = {
					subject: null,
					level: null,
					chapter: null
				}
			}
			this.isModalVisible = true
		},
		closeModal() {
			this.isModalVisible = false;
			// Réinitialiser les filtres de la modale
			this.modalFilters = {
				subject: null,
				level: null,
				chapter: null
			}
			// On modifie la référence du filtre pour déclencher le watcher dans QuestionKey.vue
			this.filter = { ...this.filter };
			if (this.$route.name === 'QuestionKey') {
				this.$root.$emit('refresh-questions');
			}
		}
	},

	mounted () {
		// const question = document.getElementById('question')
		// const key = document.getElementById('key')
		// this.questionWidth = question.offsetWidth
		// this.keyWidth = key.offsetWidth
		// this.questionPosition = question.getBoundingClientRect().left - question.getBoundingClientRect().left
		// this.keyPosition = key.getBoundingClientRect().left - question.getBoundingClientRect().left
		
		// if (this.$route.name === 'Question') {
		// 	this.spanWidth = this.questionWidth
		// 	this.spanPosition = this.questionPosition
		// } else {
		// 	this.spanWidth = this.keyWidth
		// 	this.spanPosition = this.keyPosition
		// }
		
	},

	watch: {
		$route(to) {
			if (to.name === 'Question') {
				this.spanWidth = this.questionWidth
				this.spanPosition = this.questionPosition
			} else {
				this.spanWidth = this.keyWidth
				this.spanPosition = this.keyPosition
			}
		}
	}
}
</script>

<style>
</style>
